import { Injectable } from '@angular/core';
import { TipoEstado } from './tipo-estado.model';
import { GeneralHttpService } from 'src/app/shared/general-http.service';

@Injectable({
  providedIn: 'root'
})
export class TipoEstadoService {
  listTipoEstado:TipoEstado[];
  tipoEstado:TipoEstado;
  private routeApi = "AdmTipoEstadoes";
  constructor(private generalHttp:GeneralHttpService) { }

  getEstado(){
    return this.generalHttp.getHttp(this.routeApi).then(r => this.listTipoEstado = r as TipoEstado[]);
  }

  postEstado(form:TipoEstado){
    return this.generalHttp.postHttp(form,this.routeApi);
  }

  putEstado(form:TipoEstado,id:number){
    return this.generalHttp.putHttp(form,id,this.routeApi)
  }

  getEstadoById(id:number){
    this.generalHttp.getHttpById(id,this.routeApi).then(r => this.tipoEstado = r as TipoEstado);
  }
}
